<div class="border-b border-gray-200">
  <nav aria-label="Tabs" class="-mb-px flex space-x-8">
    @for (link of links(); track link) {
      <a
        [routerLink]="link.to"
        [queryParams]="link.queryParams"
        [queryParamsHandling]="link.queryParamsHandling"
        routerLinkActive
        [routerLinkActiveOptions]="link.routerLinkActiveOptions || { exact: false }"
        #rla="routerLinkActive"
        class="border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap"
        [class]="
          rla.isActive
            ? 'border-primary-600 text-primary-600'
            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
        "
        [attr.aria-current]="rla.isActive"
      >
        {{ link.label | translate }}
      </a>
    }
  </nav>
</div>
